"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Truncate = exports.BaseTruncate = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = require("../../utils/classify");
var _qa = require("../../utils/qa");
var _TruncateModule = _interopRequireDefault(require("./Truncate.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// Props expected when Truncate wraps an existing element
// Use standard DOM attributes so `title`, `className`, etc. are recognized.

const BaseTruncate = exports.BaseTruncate = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    line = 1,
    showFullTextOnHover = false,
    wordBreak = 'break-all',
    className,
    testId
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'truncate'
    }),
    className: (0, _classify.classify)(_TruncateModule.default.truncateLineClamp, className),
    style: {
      '--line-clamp': line,
      '--word-break': wordBreak
    },
    title: showFullTextOnHover ? children : '',
    ref: ref,
    children: children
  });
});
const Truncate = exports.Truncate = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    children,
    line = 1,
    showFullTextOnHover = false,
    wordBreak = 'break-all',
    className: truncateClassName,
    testId
  } = _ref2;
  const arrayChildren = React.Children.toArray(children);
  if (arrayChildren.length) {
    const child = arrayChildren[0];
    if (/*#__PURE__*/React.isValidElement(child)) {
      const {
        className,
        children
      } = child.props;
      return /*#__PURE__*/React.cloneElement(child, {
        className: (0, _classify.classify)(_TruncateModule.default.truncateLineClamp, className, truncateClassName),
        style: {
          '--line-clamp': line,
          '--word-break': wordBreak
        },
        title: showFullTextOnHover ? children : '',
        ref,
        testId
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(BaseTruncate, {
      line: line,
      showFullTextOnHover: showFullTextOnHover,
      ref: ref,
      wordBreak: wordBreak,
      className: truncateClassName,
      testId: testId,
      children: children
    });
  }
  return null;
});